import { baseApi } from "./baseApi";

// --- Request types ---

interface SignUpRequest {
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  password: string;
}

interface SendOtpByPhoneRequest {
  phoneNumber: string;
}

interface SendOtpByEmailRequest {
  email: string;
}

type SendOtpRequest = SendOtpByPhoneRequest | SendOtpByEmailRequest;

interface ConfirmOtpRequest {
  otp: string;
}

// --- Response types ---

interface ApiResponse {
  statusCode: number;
  message: string;
}

interface ConfirmOtpResponse {
  statusCode: number;
  message?: string;
  response: {
    token: string;
    data: {
      id: string;
    };
  };
}

// --- API endpoints ---

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    signUp: builder.mutation<ApiResponse, SignUpRequest>({
      query: (data) => ({
        url: "/acquisition/quick-sign-up",
        method: "POST",
        body: {
          email: data.email.trim(),
          phoneNumber: data.phoneNumber.replace(/\D/g, ""),
          firstName: data.firstName.trim(),
          lastName: data.lastName.trim(),
          accountType: "User",
          password: data.password,
        },
      }),
    }),

    sendOtp: builder.mutation<ApiResponse, SendOtpRequest>({
      query: (data) => ({
        url: "/acquisition/send-otp",
        method: "POST",
        body: "phoneNumber" in data
          ? { phoneNumber: data.phoneNumber.replace(/\D/g, "") }
          : { email: (data as SendOtpByEmailRequest).email.trim() },
      }),
    }),

    confirmOtp: builder.mutation<ConfirmOtpResponse, ConfirmOtpRequest>({
      query: (data) => ({
        url: "/acquisition/confirm-otp",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Auth"],
    }),
  }),
});

export const {
  useSignUpMutation,
  useSendOtpMutation,
  useConfirmOtpMutation,
} = authApi;
